import ChapterStudentTable from "./ChapterStudentTable";
import { useTheme } from "styled-components";
export default function (props) {
  const theme = useTheme();

  return <ChapterStudentTable {...props} theme={theme} />;
}